import {
  Card,
  CardBody,
  CardHeader,
  Col,
  FormFeedback,
  FormGroup,
  Row,
} from "reactstrap";
import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import { useState, useEffect, useRef } from "react";
import {
  handleBlurForAttributes,
  handleInputChange,
  handleSelectInputChange,
} from "./constants/TelcoSubmitFunctions";
import SelectField from "../Utils/SelectField";

export const handleKeyPress = (e, valueType) => {
  //Allow everything for string
  if (valueType === "string") {
    return;
  }

  //Only numbers for integer
  if (valueType === "integer") {
    if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
      e.preventDefault();
    }
  }

  //Numbers + one dot for float64
  if (valueType === "float64") {
    if (!/[0-9.]/.test(e.key) && e.key !== "Backspace") {
      e.preventDefault();
    }

    // prevent multiple dots
    if (e.key === "." && e.target.value.includes(".")) {
      e.preventDefault();
    }
  }
};

export function NonSearchableAttributes({
  Attributes,
  setNonSearchableValues,
  nonSearchableValues,
  nonSearchableFormErrorsValues,
  dynamicGroups,
  setDynamicGroups,
  existingAttributes,
  isEdit,
  showGenerateButton,
}) {

  // const hasInitialized = useRef(false);

  // useEffect(() => {
  //   if (!Attributes?.length) return;

  //   // setDynamicGroups({});

  //   const listAttrs = Attributes.filter((attr) => attr.valueType === "list");

  //   const initialState = {};

  //   listAttrs.forEach((attr) => {
  //     const existing = existingAttributes?.find(
  //       (a) => a.attributeName === attr.name,
  //     );

  //     if (existing && Array.isArray(existing.attributeValue)) {
  //       initialState[attr.name] = existing.attributeValue.map((val) => ({
  //         value: val,
  //         touched: false,
  //       }));
  //     } else {
  //       initialState[attr.name] = [{ value: "", touched: false }];
  //     }
  //   });

  //   // setDynamicGroups(initialState);
  // }, [Attributes, existingAttributes]);

  useEffect(() => {
    if (!Attributes?.length) return;

    const listAttrs = Attributes.filter((attr) => attr.valueType === "list");
    if (!listAttrs.length) return;

    const initialState = {};

    listAttrs.forEach((attr) => {
      const existing = existingAttributes?.find(
        (a) => a.attributeName === attr.name,
      );

      if (existing && Array.isArray(existing.attributeValue)) {
        initialState[attr.name] = existing.attributeValue.map((val) => ({
          value: val,
          touched: false,
        }));
      } else {
        initialState[attr.name] = [{ value: "", touched: false }];
      }
    });

    setDynamicGroups(initialState); 
  }, [Attributes, existingAttributes]);


  const handleDynamicChange = (groupName, index, field, val) => {
    const updated = { ...dynamicGroups };
    updated[groupName][index][field] = val;
    setDynamicGroups(updated);
  };

  const addRow = (attr) => {
    const updated = { ...dynamicGroups };
    const rows = updated[attr.name] || [];

    if (attr.mandatory) {
      let hasError = false;

      const validatedRows = rows.map((row) => {
        const isEmpty = !row.value || row.value.trim() === "";

        if (isEmpty) {
          hasError = true;
          return { ...row, touched: true };
        }

        return row;
      });

      if (hasError) {
        updated[attr.name] = validatedRows;
        setDynamicGroups(updated);
        return;
      }
    }

    updated[attr.name] = [...rows, { value: "", touched: false }];

    setDynamicGroups(updated);
  };

  const handleDynamicBlur = (groupName, index) => {
    const updated = { ...dynamicGroups };

    if (!updated[groupName]) return;

    updated[groupName][index].touched = true;

    setDynamicGroups(updated);
  };

  const removeRow = (groupName, index) => {
    const updated = { ...dynamicGroups };
    updated[groupName] = updated[groupName].filter((_, i) => i !== index);
    setDynamicGroups(updated);
  };

  const generateReference = () => {
    const today = new Date();

    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();

    const datePart = `${dd}${mm}${yyyy}`;

    // Random + timestamp (KSUID-like)
    const randomPart =
      Math.random().toString(36).substring(2, 8).toUpperCase() +
      Date.now().toString(36).toUpperCase();

    return `PG-${datePart}-${randomPart}`;
  };

  return (
    <Row>
      <Col lg={12}>
        {Attributes?.length ? (
          <>
            <h4 className="card-title flex-grow-1 rv-form-title">Attributes</h4>
            <Row className="gy-2 pe-2">
              {Attributes?.filter((value) => value.valueType !== "list").map(
                (value, index) => {
                  const attrValue =
                    nonSearchableValues.find(
                      (attr) => attr.name === value.name,
                    ) || {};
                  const checkIfKeyIsPresentInArray = () =>
                    nonSearchableFormErrorsValues &&
                    nonSearchableValues &&
                    Object.keys(nonSearchableFormErrorsValues).some((key) =>
                      nonSearchableValues.some(
                        (element) => element.name === key,
                      ),
                    );
                  const check = checkIfKeyIsPresentInArray();
                  const convertedValue = value?.values
                    ? value?.values.map((item) => ({
                        label: item,
                        value: item,
                      }))
                    : [];
                  return (
                    <Col xxl={3} md={6} className="pe-0" key={value?.name}>
                      <FormGroup>
                        <LabelText
                          important={value.mandatory && "*"}
                          classLabelName={"ms-0 rv-form-label"}
                          className={value.mandatory && "text-danger"}
                          displayText={value.name}
                        />
                        {(value.mandatory &&
                          nonSearchableValues[index]?.value === "" &&
                          nonSearchableValues[index]?.touched) ||
                        (check &&
                          nonSearchableValues[index]?.value === "" &&
                          value.mandatory) ? (
                          <p className="rv-sub-label rv-label-danger">
                            {`${
                              value?.values === null || !value?.values?.length
                                ? "Enter"
                                : "Select"
                            }  ${value?.name}`}
                          </p>
                        ) : value.mandatory &&
                          check &&
                          value.valueType !== "list" &&
                          nonSearchableValues[index]?.value.length <
                            value.minValue ? (
                          <p className="rv-sub-label rv-label-danger">
                            Minimum length is {value.minValue} characters.
                          </p>
                        ) : value.mandatory &&
                          check &&
                          value.valueType !== "list" &&
                          nonSearchableValues[index]?.value.length >
                            value.maxValue ? (
                          <p className="rv-sub-label rv-label-danger">
                            Maximum length is {value.maxValue} characters.
                          </p>
                        ) : (
                          <LabelText
                            htmlFor={value?.name}
                            classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                            displayText={`${
                              value?.values === null || !value?.values?.length
                                ? "Enter"
                                : "Select"
                            }  ${value?.name}`}
                          />
                        )}
                        {value?.values === null || !value?.values?.length ? (
                          <InputField
                            type="text"
                            onKeyDown={(e) =>
                              handleKeyPress(e, value.valueType)
                            }
                            value={
                              attrValue?.value ??
                              value?.currentSequence ??
                              value?.sequenceValue ??
                              ""
                            }
                            maxLength={value?.maxValue}
                            minLength={value?.minValue}
                            disabled={false}
                            handleChange={(e) => {
                              let input = e.target.value;

                              if (value.valueType === "integer") {
                                input = input.replace(/[^0-9]/g, "");
                              } else if (value.valueType === "float64") {
                                input = input.replace(/[^0-9.]/g, "");
                              }

                              handleInputChange(
                                value.name,
                                input,
                                setNonSearchableValues,
                              );
                            }}
                            handleBlur={() =>
                              handleBlurForAttributes(
                                value.name,
                                setNonSearchableValues,
                              )
                            }
                          />
                        ) : (
                          <SelectField
                            className={
                              (value.mandatory &&
                                nonSearchableValues[index]?.value == "" &&
                                nonSearchableValues[index]?.touched) ||
                              (check &&
                                nonSearchableValues[index]?.value == "" &&
                                value.mandatory) ||
                              false
                                ? "error-input"
                                : ""
                            }
                            options={convertedValue}
                            value={
                              nonSearchableValues[index]?.value
                                ? convertedValue.filter(
                                    (item) =>
                                      item.value ===
                                      nonSearchableValues[index]?.value,
                                  )
                                : nonSearchableValues[index]?.value
                            }
                            handleChange={(e) => {
                              handleSelectInputChange(
                                value.name,
                                e,
                                setNonSearchableValues,
                              );
                            }}
                            placeholder={" "}
                            isRVStyle={true}
                          />
                        )}
                      </FormGroup>
                    </Col>
                  );
                },
              )}
            </Row>

            {Attributes?.filter((attr) => attr.valueType === "list").map(
              (attr) => (
                <Row className="mt-3" key={attr.name}>
                  <Col lg={12}>
                    <LabelText
                      important={attr.mandatory && "*"}
                      classLabelName={"ms-0 rv-form-label fs-5"}
                      className={attr.mandatory && "text-danger"}
                      displayText={attr.name}
                    />

                    {(dynamicGroups[attr.name] || []).map((row, index) => (
                      <Row key={index} className="gy-2 align-items-center pe-2">
                        {/* VALUE FIELD */}
                        <Col xxl={3} md={6} sm={12} className="pe-0">
                          <FormGroup>
                            {index === 0 && (
                              <LabelText
                                classLabelName="ms-0 rv-form-label"
                                displayText="Value"
                              />
                            )}

                            <div style={{ position: "relative" }}>
                              <InputField
                                type="text"
                                value={row.value}
                                maxLength={
                                  attr?.maxValue > 0 ? attr.maxValue : undefined
                                }
                                handleChange={(e) =>
                                  handleDynamicChange(
                                    attr.name,
                                    index,
                                    "value",
                                    e.target.value,
                                  )
                                }
                                handleBlur={() =>
                                  handleDynamicBlur(attr.name, index)
                                }
                                placeholder="Enter A Value"
                                invalid={
                                  attr.mandatory &&
                                  (nonSearchableFormErrorsValues?.[attr.name] ||
                                    row.touched) &&
                                  (!row.value || row.value.trim() === "")
                                }
                                style={{ paddingRight: "90px" }}
                              />

                              {showGenerateButton && (
                                <button
                                  type="button"
                                  className="btn btn-sm"
                                  style={{
                                    position: "absolute",
                                    right: "5px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    height: "25px",
                                    border: "1px solid #4F4F4F",
                                    color: "#4F4F4F",
                                    backgroundColor: "white",
                                  }}
                                  onClick={() => {
                                    const ref = generateReference();
                                    handleDynamicChange(
                                      attr.name,
                                      index,
                                      "value",
                                      ref,
                                    );
                                  }}
                                >
                                  Generate
                                </button>
                              )}
                            </div>
                          </FormGroup>
                        </Col>

                        {/* PRIORITY FIELD */}
                        {/* <Col xxl={3} md={6} sm={12} className="pe-0">
                          <FormGroup>
                            <LabelText
                              classLabelName="ms-0 rv-form-label"
                              displayText="Priority"
                            />
                            <InputField
                              type="text"
                              value={row.priority}
                              onKeyDown={(e) => handleKeyPress(e, "integer")}
                              handleChange={(e) =>
                                handleDynamicChange(
                                  attr.name,
                                  index,
                                  "priority",
                                  e.target.value,
                                )
                              }
                              placeholder="Enter Priority"
                            />
                          </FormGroup>
                        </Col> */}

                        {/* ACTION BUTTONS */}
                        <Col
                          md={2}
                          sm={12}
                          className={`d-flex gap-2 ${index === 0 ? "mt-4" : "mt-0"}`}
                        >
                          {index === dynamicGroups[attr.name]?.length - 1 && (
                            <i
                              className="ri-add-circle-line text-primary fs-5"
                              style={{ cursor: "pointer" }}
                              onClick={() => addRow(attr)}
                              title="Add Row"
                            />
                          )}

                          {/* DELETE BUTTON */}
                          {dynamicGroups[attr.name]?.length > 1 && (
                            <i
                              className="ri-delete-bin-5-line text-danger fs-5"
                              style={{ cursor: "pointer" }}
                              onClick={() => removeRow(attr.name, index)}
                              title="Delete Row"
                            />
                          )}
                        </Col>
                      </Row>
                    ))}
                  </Col>
                </Row>
              ),
            )}
          </>
        ) : null}
      </Col>
    </Row>
  );
}
